const SECONDS_IN_A_MINUTE = 60;

export const SECONDS_BEFORE_SHOWING_ELAPSED_TIME = 10;

export function formatElapsedTime(elapsedSeconds: number): string {
  if (elapsedSeconds < SECONDS_IN_A_MINUTE) {
    return `${elapsedSeconds}s`;
  }

  const minutes = Math.floor(elapsedSeconds / SECONDS_IN_A_MINUTE);
  const seconds = String(elapsedSeconds % SECONDS_IN_A_MINUTE).padStart(2, '0');

  return `${minutes}m ${seconds}s`;
}
